import AbstractAnalyticProvider from 'coreClasses/analytics/providers/AbstractAnalyticProvider';
import {IAnalyticsProvidersConfiguration} from 'coreClasses/analytics/IAnalytics';

import ManagerRepository from 'brandClasses/ManagerRepository';

import AnalyticsProvidersMgr from './providers/AnalyticsProvidersMgr';

/**
 * Represents brand-level AnalyticsMgr
 */
class AnalyticsMgr {
	/**
	 * Get analytics providers
	 * @param {IAnalyticsProvidersConfiguration} providersConfiguration - map of providers configs
	 * @returns {AbstractAnalyticProvider[]} - list of providers
	 */
	public static getAnalyticsProviders(
		providersConfiguration: IAnalyticsProvidersConfiguration,
		managerRepository: ManagerRepository
	): AbstractAnalyticProvider[] {
		if (providersConfiguration) {
			const analyticsProvidersIDs = Object.keys(providersConfiguration);

			return analyticsProvidersIDs.reduce((acc, id) => {
				const provider = AnalyticsProvidersMgr.getAnalyticsProvider(
					id,
					managerRepository,
					providersConfiguration
				);

				if (provider) {
					acc.push(provider);
				}

				return acc;
			}, []);
		}

		return [];
	}
}

export default AnalyticsMgr;
